<template>
	<div>
		<template v-if="qzWebsocket === true">
			<CSelect
				label="Imprimante"
				class="printer-select"
				:options="printers"
				:value="printer"
				@change="printerSelect($event)" />
		</template>
		<template v-else>
			<b>Connexion à l'ordinateur en cours..</b>
		</template>
	</div>
</template>

<script>
	export default {
		name: 'select-printer',
		data() {
			return {
				printer: this.$cookies.get('default_printer') ?? null,
				printers: [],
				qzWebsocket: false,
			};
		},

		async mounted() {
			// set digital certificate
			await this.$qz.security.setCertificatePromise(function (resolve, reject) {
				resolve(
					'-----BEGIN CERTIFICATE-----\n' +
						'MIIECzCCAvOgAwIBAgIGAXwPMVl1MA0GCSqGSIb3DQEBCwUAMIGiMQswCQYDVQQG\n' +
						'EwJVUzELMAkGA1UECAwCTlkxEjAQBgNVBAcMCUNhbmFzdG90YTEbMBkGA1UECgwS\n' +
						'UVogSW5kdXN0cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMx\n' +
						'HDAaBgkqhkiG9w0BCQEWDXN1cHBvcnRAcXouaW8xGjAYBgNVBAMMEVFaIFRyYXkg\n' +
						'RGVtbyBDZXJ0MB4XDTIxMDkyMTIwMjc0NFoXDTQxMDkyMTIwMjc0NFowgaIxCzAJ\n' +
						'BgNVBAYTAlVTMQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYD\n' +
						'VQQKDBJRWiBJbmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMs\n' +
						'IExMQzEcMBoGCSqGSIb3DQEJARYNc3VwcG9ydEBxei5pbzEaMBgGA1UEAwwRUVog\n' +
						'VHJheSBEZW1vIENlcnQwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCb\n' +
						'rlLKNQo1dfCEHoJvQUq4ZArtEu/sYlZcepvuWiWAk+RGwEFSniKMogRtlcWRE2nH\n' +
						'w0h9Eo0D9V/ZKYxRTWKh2WMwGkFCyFNgUp6IBGgVAhnc6B18TPYdsO0JatwgWRMA\n' +
						'ONNGsCdaCuWCI558j+vrUtQIGfjsikAICrGaVQCceh/1BfA3+3R+cl6LvppD0x4q\n' +
						'EhNEkspzGHTcxrlisUfRKARmbLM8pkbIblVdOAX3OJbCshD571Rwk02Lehnl93r4\n' +
						'vqRrGRit3U7f6Cfg3+pUi1Y6JB+gIWaZduJKWAUqZZ0rT3j2H9sB4rY7jEqcQLpU\n' +
						'qVQ8ok0desVr3GeegqVRAgMBAAGjRTBDMBIGA1UdEwEB/wQIMAYBAf8CAQEwDgYD\n' +
						'VR0PAQH/BAQDAgEGMB0GA1UdDgQWBBQNSPXSxJtbrHVd4Rm7FzRRwMskOTANBgkq\n' +
						'hkiG9w0BAQsFAAOCAQEAJfwb8DqyD9q1Z5A7OlC49b2vE3us75VWMpZMEeJQUwj1\n' +
						'O/sQa1cloML5tWQNog5VilHmAJXL0JWyvunLe6WzgahYrrB6HUesmVNX/BoCHa5Z\n' +
						'OqLgErcVvcZuMYT+P5runCMlfxYUweZHGESbFErl8MNNynAWfSQEqPgAWraWICd9\n' +
						'J93tMRdRV4TnzJ57ZWuCE7WfxV3ApU5jONpglEBWBuCX1bJvinC3i9O2rbdzbBe7\n' +
						'CToaNn0O//tZO5it3guKSdAJMoyU3Jg00oCLgHjVHWNsfFBPRcwviWcXlE1aP/V1\n' +
						'DrmIoT6/OGzjKYgpbJ3ySOl9zphSvjAseC1996o3aA==\n' +
						'-----END CERTIFICATE-----'
				);
			});

			// set signature (server side)
			this.$qz.security.setSignatureAlgorithm('SHA512'); // Since 2.1
			await this.$qz.security.setSignaturePromise(toSign => {
				return (resolve, reject) => {
					this.$axios
						.get(`/api/qztray/sign/${toSign}`, {
							cache: 'no-store',
							headers: { 'Content-Type': 'text/plain' },
						})
						.then(res => {
							resolve(res.data);
						});
				};
			});

			if (this.$qz.websocket.isActive()) {
				this.qzWebsocket = true;
			} else {
				this.$qz.websocket.connect().then(() => {
					this.qzWebsocket = true;
				});
			}
		},

		watch: {
			qzWebsocket: function () {
				if (this.qzWebsocket === true) {
					this.$qz.printers.find().then(data => {
						this.printers = data;

						if (this.printer == null && data.length > 0) {
							this.printer = data[0];
						}
					});
				}
			},
		},

		methods: {
			printerSelect($event) {
				this.printer = $event.target.value;
				this.$cookies.set('default_printer', $event.target.value, { expires: 365 });
			},

			async send(data) {
				let config = await this.$qz.configs.create(this.printer); // Exact printer name from OS

				return this.$qz
					.print(config, [data])
					.then(function () {
						// printer successfully received data
						return true;
					})
					.catch(err => {
						// error on transmission
						return err;
					});
			},
		},
	};
</script>

<style scoped>
	.printer-select {
		max-width: 300px;
	}
</style>
